import Swiper from "swiper"
export default new (class NewRecipesCarousel {
    constructor() {
        this.sliderContainerSelector = "carousel-new-recipes"
        this.handler()
    }

    handler() {
        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.${this.sliderContainerSelector}`).forEach((item) => {
            if (item.classList.contains('swiper-initialized')) return;
            new Swiper(item, {
                slidesPerView: 2.5,
                spaceBetween: 16,
                centerInsufficientSlides: true,
                breakpoints: {
                    300: {
                        slidesPerView: 1.2,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                },
            })
        })
        document.querySelectorAll(`.carousel-popular-recipes`).forEach((item) => {
            if (item.classList.contains('swiper-initialized')) return;
            new Swiper(item, {
                slidesPerView: 2.5,
                spaceBetween: 16,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    300: {
                        slidesPerView: 1.2,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    },
                },
            })
        })
    }
})()
